import { Component, HostBinding, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import ace from 'ace-builds';
import { ThemeService, ThemeModel } from '../../../services/theme.service';
import { startWith } from 'rxjs/operators';
import { ElementDataImport, ElementService } from '../../service/element.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'common-import-set',
	templateUrl: './import-set.component.html',
	styleUrls: ['./import-set.component.scss']
})
export class ImportSetComponent implements OnInit, OnDestroy {
	@HostBinding('class.c-import-set') hostClass = true;
	themeModel: ThemeModel;
	public svr = this.elementSvr.data.import as ElementDataImport;
	tableControl = new FormControl();
	options: any = { maxLines: 12, printMargin: false };
	tables: string[];
	subs: Subscription[] = [];
	constructor(public elementSvr: ElementService, private theme: ThemeService) {
		this.subs.push(
			this.theme.theme.subscribe(v => {
				this.themeModel = v.model;
			})
		);
	}
	ngOnDestroy() {
		this.subs.forEach(v => v.unsubscribe());
	}

	ngOnInit() {
		ace.config.set('basePath', '/front/assets/ace-builds/src-min-noconflict');
		this.subs.push(
			this.svr.init().subscribe(() => {
				this.tableControl.patchValue(this.svr.Params.Table);
				this.subs.push(
					// åä¸å¥ç¨äºstartWith '' ï¼æä»¥å¿é¡»å¦å¤è®¢éãå¦åä¼æ¯æ¬¡é½æ¸ç©º
					this.tableControl.valueChanges.subscribe(v => {
						this.svr.Params.Table = v;
						this.svr.syncTableColumn();
					}),
					this.tableControl.valueChanges.pipe(startWith('')).subscribe(v => {
						this.tables = this.svr.Tables.filter(sv => sv.toUpperCase().includes(v.toUpperCase()));
					})
				);
			})
		);
	}
}
